import React from "react";
import { Link } from "react-router-dom";
import { inject, observer } from "mobx-react";

const NavbarItem = ({ 
    data,
    path, 
    currentPath, 
    translationKey, 
    text, 
    hasAccess = true,
    showBorder = true 
}) => {
    if (!hasAccess) return null;

    const isActive = currentPath === path;
    const baseClasses = "nav-item";
    const activeClass = isActive ? "active" : "";
    const borderClass = showBorder ? "custom-border-right" : "";
    
    const className = [baseClasses, activeClass, borderClass].filter(Boolean).join(" ");
    
    const displayText = text || (data && translationKey ? data.t.read(translationKey) : "");

    return (
        <div className={className}>
            <Link to={path} className="nav-link border-0">
                <span>{displayText}</span>
            </Link>
        </div>
    );
};

export default inject("data")(observer(NavbarItem));
